import { CalcularDigitoVerificacion, VerificarResponsabilidadTributaria } from '../../../Utils/ElectronicInvoice';

const EMITags = (doc, data, clinica, typeDocumentInvoice) => {

    //ETIQUETA PADRE
    var EMI = doc.createElement("EMI");

    //Tipo de Emisor  1-Persona Juridica, 2-Persona Natural
    var EMI_1 = doc.createElement("EMI_1");
    EMI_1.innerHTML = 1;
    EMI.appendChild(EMI_1);

    //NIT del Emisor
    var EMI_2 = doc.createElement("EMI_2");
    EMI_2.innerHTML = clinica.nit.split("-")[0];
    EMI.appendChild(EMI_2);

    //Tipo de Identificador Fiscal
    var EMI_3 = doc.createElement("EMI_3");
    EMI_3.innerHTML = 31;
    EMI.appendChild(EMI_3);

    //Excepcion de IVA (SIN IVA = 2, Con IVA = 0)
    /*
    var EMI_4 = doc.createElement("EMI_4");
    EMI_4.innerHTML = 2;
    EMI.appendChild(EMI_4);
    */

    //Numero Interno
    var EMI_5 = doc.createElement("EMI_5");
    EMI_5.innerHTML = " ";
    EMI.appendChild(EMI_5);

    //Razon Social del Emisor
    var EMI_6 = doc.createElement("EMI_6");
    EMI_6.innerHTML = clinica.nombre;
    EMI.appendChild(EMI_6);

    //Nombre Comercial del Emisor
    var EMI_7 = doc.createElement("EMI_7");
    EMI_7.innerHTML = clinica.nombre;
    EMI.appendChild(EMI_7);

    //Direccion de la Clinica
    var EMI_10 = doc.createElement("EMI_10");
    EMI_10.innerHTML = clinica.direccion.direccion;
    EMI.appendChild(EMI_10);

    //Codigo del Departamento
    var EMI_11 = doc.createElement("EMI_11");
    EMI_11.innerHTML = clinica.direccion.depcod;
    EMI.appendChild(EMI_11);

    //Nombre de la Ciudad
    var EMI_13 = doc.createElement("EMI_13");
    EMI_13.innerHTML = clinica.localidad.ciudad.toUpperCase();
    EMI.appendChild(EMI_13);

    //Codigo Postal
    var EMI_14 = doc.createElement("EMI_14");
    EMI_14.innerHTML = clinica.codigo_postal;
    EMI.appendChild(EMI_14);

    //Codigo del Pais
    var EMI_15 = doc.createElement("EMI_15");
    EMI_15.innerHTML = "CO";
    EMI.appendChild(EMI_15);

    //Codigo del Pais
    var EMI_19 = doc.createElement("EMI_19");
    EMI_19.innerHTML = clinica.localidad.dpto.toUpperCase();
    EMI.appendChild(EMI_19);

    //Nombre del Pais
    var EMI_21 = doc.createElement("EMI_21");
    EMI_21.innerHTML = "COLOMBIA";
    EMI.appendChild(EMI_21);

    //Digito de Verificacion -DV
    var EMI_22 = doc.createElement("EMI_22");
    EMI_22.innerHTML = CalcularDigitoVerificacion(clinica.nit.split("-")[0]);
    EMI.appendChild(EMI_22);

    //Codigo de la Ciudad
    var EMI_23 = doc.createElement("EMI_23");
    EMI_23.innerHTML = clinica.direccion.ciucod;
    EMI.appendChild(EMI_23);

    //Nombre de la Clinica o IPS
    var EMI_24 = doc.createElement("EMI_24");
    EMI_24.innerHTML = clinica.nombre;
    EMI.appendChild(EMI_24);

    //Codigo de Actividad Economica
    var EMI_25 = doc.createElement("EMI_25");
    EMI_25.innerHTML = "8699";//clinica.cod_act_econ;
    EMI.appendChild(EMI_25);

    //Etiquetas Hijas
    EMI.appendChild(TACTags(doc, data, clinica));
    EMI.appendChild(DFETags(doc, data, clinica));
    EMI.appendChild(ICCTags(doc, data, clinica, typeDocumentInvoice));
    EMI.appendChild(CDETags(doc, data, clinica));
    EMI.appendChild(GTETags(doc, data, clinica));

    return EMI;
}

const TACTags = (doc, data, clinica) => {
    var TAC = doc.createElement("TAC");

    //Obligaciones del Contribuyente
    var TAC_1 = doc.createElement("TAC_1");
    TAC_1.innerHTML = VerificarResponsabilidadTributaria(clinica.tipo_responsabilidad);
    TAC.appendChild(TAC_1);

    return TAC;
}

const DFETags = (doc, data, clinica) => {
    var DFE = doc.createElement("DFE");

    //Codigo de la Ciudad del Emisor
    var DFE_1 = doc.createElement("DFE_1");
    DFE_1.innerHTML = clinica.direccion.ciucod;
    DFE.appendChild(DFE_1);

    //Codigo del Departamento del Emisor
    var DFE_2 = doc.createElement("DFE_2");
    DFE_2.innerHTML = clinica.direccion.depcod;
    DFE.appendChild(DFE_2);

    //Codigo del PAIS (Abreviatura)
    var DFE_3 = doc.createElement("DFE_3");
    DFE_3.innerHTML = "CO";
    DFE.appendChild(DFE_3);

    //Codigo Postal
    var DFE_4 = doc.createElement("DFE_4");
    DFE_4.innerHTML = clinica.codigo_postal;
    DFE.appendChild(DFE_4);

    //Codigo Postal
    var DFE_5 = doc.createElement("DFE_5");
    DFE_5.innerHTML = "COLOMBIA";
    DFE.appendChild(DFE_5);

    //Nombre del Departamento
    var DFE_6 = doc.createElement("DFE_6");
    DFE_6.innerHTML = clinica.localidad.dpto;
    DFE.appendChild(DFE_6);

    //Nombre de la Ciudad
    var DFE_7 = doc.createElement("DFE_7");
    DFE_7.innerHTML = clinica.localidad.ciudad;
    DFE.appendChild(DFE_7);

    //Dirección de la Empresa
    var DFE_8 = doc.createElement("DFE_8");
    DFE_8.innerHTML = data.clinica.direccion.direccion;
    DFE.appendChild(DFE_8);

    return DFE;
}

const ICCTags = (doc, data, clinica, typeDocumentInvoice) => {
    var ICC = doc.createElement("ICC");

    //Codigo Mercantil de la IPS
    /*var ICC_1 = doc.createElement("ICC_1");
    ICC_1.innerHTML = clinica.nit;
    ICC.appendChild(ICC_1);
    */

    //Prefijo de la IPS
    var ICC_9 = doc.createElement("ICC_9");
    ICC_9.innerHTML = typeDocumentInvoice == "INVOICE" ? data.detallesFacturacion.prefijo : data.detallesReferenciaFactura.prefijo;
    ICC.appendChild(ICC_9);

    return ICC;
}

const CDETags = (doc, data, clinica) => {
    var CDE = doc.createElement("CDE");

    //Contacto de Ventas
    var CDE_1 = doc.createElement("CDE_1");
    CDE_1.innerHTML = 4;
    CDE.appendChild(CDE_1);

    //Nombre del Cargo de la Persona de Contacto
    var CDE_2 = doc.createElement("CDE_2");
    CDE_2.innerHTML = clinica.nombre;
    CDE.appendChild(CDE_2);

    //Nombre del Cargo de la Persona de Contacto
    var CDE_3 = doc.createElement("CDE_3");
    CDE_3.innerHTML = clinica.telefono1;
    CDE.appendChild(CDE_3);

    //Prueba
    var CDE_4 = doc.createElement("CDE_4");
    CDE_4.innerHTML = clinica.email;
    CDE.appendChild(CDE_4);

    return CDE;
}

const GTETags = (doc, data, clinica) => {
    var GTE = doc.createElement("GTE");

    //Codigo de Responsable de IVA
    var GTE_1 = doc.createElement("GTE_1");
    GTE_1.innerHTML = "ZZ";
    GTE.appendChild(GTE_1);

    //Iva
    var GTE_2 = doc.createElement("GTE_2");
    GTE_2.innerHTML = "NO APLICA";
    GTE.appendChild(GTE_2);

    return GTE;
}

export default EMITags;